import { getRedirectTarget } from '@clientShared/hreflangRedirect';
import { globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import { hasClass, removeCss, toggleClass } from '@shared/easyfy.utils';

@invoke
export default class CountrySelector {
  private cssClass: string = 'expanded';
  private countrySelector: HTMLElement | null = null;
  private countryList: HTMLElement | null = null;

  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'toggle-countries',
          callback: this.showCountries,
        },
      ],
    });
  }

  showCountries = (e: Event) => {
    e.stopPropagation();

    const target = e.target as HTMLElement;
    this.countrySelector = target.closest('.country-selector');
    if (!this.countrySelector) return;

    this.countryList = target.parentElement?.querySelector<HTMLElement>('[data-container="country-list"]') ?? null;

    toggleClass(this.countrySelector, this.cssClass);

    if (hasClass(this.countrySelector, this.cssClass)) {
      this.applyRedirectTargets();
      document.addEventListener('click', this.closeOnEvent);
      document.addEventListener('scroll', this.closeOnEvent);
    } else {
      this.removeEventListeners();
    }
  };

  applyRedirectTargets = () => {
    if (!this.countryList) return;

    this.countryList.querySelectorAll<HTMLAnchorElement>('a[data-country-code]').forEach((link) => {
      const countryCode = link.dataset.countryCode ?? '';
      if (!countryCode) return;

      const fallbackUrl = link.dataset.fallbackUrl ?? link.href;
      link.href = getRedirectTarget(fallbackUrl, countryCode);
    });
  };

  closeOnEvent = (e: Event) => {
    const target = e.target as HTMLElement;

    if (e.type === 'click' && this.countrySelector?.contains(target)) return;

    if (this.countrySelector) {
      removeCss(this.countrySelector, this.cssClass);
    }
    this.countrySelector = null;
    this.countryList = null;
    this.removeEventListeners();
  };

  removeEventListeners = () => {
    document.removeEventListener('click', this.closeOnEvent);
    document.removeEventListener('scroll', this.closeOnEvent);
  };
}
